import { Component, Input, OnInit } from '@angular/core';
import { BaseComponent } from '@portals/core';
import * as Highcharts from 'highcharts';

// Import the Highcharts modules

import Wordcloud from 'highcharts/modules/wordcloud';
import { CollectibleService } from '@portals/api';
import { tap } from 'rxjs';

// Initialize the modules
// Histogram(Highcharts);
// Exporting(Highcharts);
// ExportData(Highcharts);
// Accessibility(Highcharts);
Wordcloud(Highcharts);
interface WordData {
	id: string;
	name: string;
	count: number;
}

@Component({
	selector: 'portals-dashboard-word-cloud',
	templateUrl: './word-cloud.component.html',
	styleUrls: ['./word-cloud.component.scss'],
})
export class WordCloudComponent extends BaseComponent implements OnInit {
	@Input() titleShow = true;
	@Input() data: WordData[] = [];
	@Input() notificationId!: number;
	chart: any;

	constructor(public collectibleService: CollectibleService) {
		super();
	}

	ngOnInit() {
		// Step 1: Calculate the total count
		const totalCount = this.data.reduce((acc, item) => acc + item.count, 0);

		this.data = this.data.map((item) => ({
			weight: (item.count / totalCount) * 100,
			...item,
		}));

		const options: Highcharts.Options = {
			plotOptions: {
				wordcloud: {
					placementStrategy: 'center',
					spiral: 'rectangular',
					maxFontSize: 40,
				},
			},
			chart: {
				width: 700
			},
			accessibility: {
				screenReaderSection: {
					beforeChartFormat: '<h5>{chartTitle}</h5>' + '<div>{chartSubtitle}</div>' + '<div>{chartLongdesc}</div>' + '<div>{viewTableButton}</div>',
				},
			},
			series: [
				{
					type: 'wordcloud',
					data: this.data,
					name: 'Occurrences',
				},
			],
			title: {
				text: '',
			},
			tooltip: {
				headerFormat: '<span style="font-size: 16px"><b>{point.key}</b></span>',
				pointFormat: '<br>Count: <b>{point.count}</b>',
			},
		};

		this.chart = Highcharts.chart('wordCloudContainer', options);
	}

	refreshData() {
		this.collectibleService
			.momentQuery(this.notificationId)
			.pipe(
				tap((data: WordData[]) => {
					// Step 1: Calculate the total count
					const totalCount = data.reduce((acc, item) => acc + item.count, 0);
					this.data = data.map((item) => ({
						weight: (item.count / totalCount) * 100,
						...item,
					}));

					this.chart.series[0].setData(this.data, true);
				})
			)
			.subscribe();
	}
}
